import { ReferenceTableItemAttributesReplacedEvent, } from '../event/reference-table-item-attributes-replaced.event';
import { ReferenceTableItemEntity } from '../reference-table-item.entity';
const referenceTableItemAttributesReplacedProjections = {
    [ReferenceTableItemAttributesReplacedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        const newItems = new Map(state.items);
        const item = new ReferenceTableItemEntity({
            id: payload.itemId,
            attributes: payload.attributes,
            tp2LookupTableItemId: payload.tp2LookupTableItemId,
        });
        newItems.set(payload.itemId, item);
        return {
            ...state,
            items: newItems,
        };
    },
};
export default referenceTableItemAttributesReplacedProjections;
//# sourceMappingURL=reference-table-item-attributes-replaced.projection.js.map